import styled from 'styled-components'
import { DolaThemes } from '../../styles/types'
import { InputModes } from '../Input'

export interface InputBaseStyleProps {
  dolaTheme: DolaThemes
  mode: InputModes
}

export const Select = styled.select`
  left: 0;
  position: absolute;
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;
  z-index: 1;
`

export const Content = styled.div`
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: space-between;
  width: 100%;
`